export default __webpack_public_path__ + "d8aa5b79f10f3c50b3e461a7068a9d42.png";